const Dashboard = () => import("../layouts/dashboard.vue");
const AppExports = () => import("../pages/exports.vue");

/**
 * @type {import('vue-router').RouteConfig[]}
 */
export const exportsRoutes = [
  {
    path: "/exportacoes",
    component: Dashboard,
    meta: { requiresAuth: true },
    children: [
      {
        path: "",
        component: AppExports,
      },
    ],
  },
];
